export default "__VITE_ASSET__B7JEtE03__"